import { render, staticRenderFns } from "./LotViewNft.vue?vue&type=template&id=cbb1e152&scoped=true&"
import script from "./LotViewNft.vue?vue&type=script&lang=js&"
export * from "./LotViewNft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb1e152",
  null
  
)

export default component.exports